










































import { mqShallShowSidebarLeft } from "@/composables/v3/useUx";
import { useChatsStore } from "@/store/useChatsStore";
import ChatList from "@/views/modules/messaging-inbox/chat-list/chatList.vue";
import ChatListChat from "@/views/modules/messaging-inbox/chat-list/components/chatListChat.vue";
import ChatListFilters from "@/views/modules/messaging-inbox/filters/filters.vue";
import { defineComponent } from "@vue/composition-api";
import { BPagination } from "bootstrap-vue";

export default defineComponent({
    components: {
        BPagination,
        ChatList,
        ChatListFilters,
        ChatListChat,
    },
    emits: ["open-chat"],
    setup() {
        const chatsStore = useChatsStore();

        return {
            chatsStore,
            mqShallShowSidebarLeft,
        };
    },
});
